import * as React from 'react'
import { SVGProps } from 'react'

const SvgPaxosStandartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M0 0h24v24H0z' />
    <path
      d='M5.455 20.44a8.14 8.14 0 0 0 2.348 1.874 8.098 8.098 0 0 0 3.273.918 5.1 5.1 0 0 0 3.433-1.527c.32-.29.79-.7 1.367-1.188 1.277-1.09 1.932-1.643 2.682-2.15.385-.263.905-.584 1.547-.917.34-.174.686-.328 1.04-.469a4.648 4.648 0 0 0 1.925-1.457 4.63 4.63 0 0 0 .93-2.502 7.072 7.072 0 0 0-.404-1.957 7.025 7.025 0 0 0-.725-1.476 21.309 21.309 0 0 1-6.77 7.315c-4.383 2.92-8.69 3.427-10.646 3.536Z'
      fill='#0293D6'
    />
    <path
      d='M7.912 2.222c.25-.257.571-.54.988-.796C9.98.76 11.057.656 11.634.643c.27-.019.648-.019 1.091.096a3.45 3.45 0 0 1 1.335.694 11.18 11.18 0 0 0 5.583 1.982c.173.007.423.02.718.071.527.096 1.701.302 2.458 1.258.59.744.655 1.604.661 2.008-.02.417-.077.905-.192 1.444a8.958 8.958 0 0 1-.418 1.4L7.912 2.221Z'
      fill='#EBE638'
    />
    <path
      d='M5.455 20.44a8.248 8.248 0 0 1-2.22-.603c-.906-.392-2.048-.88-2.722-2.067C.083 17.013 0 16.25 0 15.736a8.983 8.983 0 0 1 .956-3.947 18.386 18.386 0 0 0 1.251-4.652c.077-.545.18-.988.27-1.302.186-.674.36-1.284.815-1.913.257-.359.526-.616.706-.77a6.074 6.074 0 0 1 2.073-.847 5.899 5.899 0 0 1 1.848-.083 20.026 20.026 0 0 0-3.433 8.63 19.948 19.948 0 0 0 .969 9.588Z'
      fill='#BAD147'
    />
    <path
      d='M7.912 2.222c-.102-.007 3.446.224 5.622.982.648.224 1.238.481 1.777.744-.7-.045-5.165-.244-8.58 3.19-4.28 4.305-2.887 10.305-2.81 10.639a6.458 6.458 0 0 1-1.393-4.434c.045-1.22.257-2.85.912-4.66 1.212-3.33 3.292-5.434 4.472-6.461Z'
      fill='#78B650'
    />
    <path
      d='M16.486 18.098a12.815 12.815 0 0 0 1.617-6.52C18 7.58 16.03 4.846 15.318 3.948c.404.064.988.193 1.662.443 1.476.558 2.413 1.38 3.26 2.137.725.648 1.7 1.643 2.63 3.067a18.939 18.939 0 0 1-2.04 3.915 19.541 19.541 0 0 1-4.344 4.588Z'
      fill='#2F8260'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.42 3.948a7.794 7.794 0 0 1 3.145 2.824 7.757 7.757 0 0 1 1.174 4.383c-.148 4.164-2.997 6.808-3.266 7.04-1.93 1.654-4.12 2.075-5.096 2.262l-.012.002c-.847.16-1.566.206-2.086.212-.622.039-1.335.045-2.117-.02a15.241 15.241 0 0 1-1.605-.211 10.736 10.736 0 0 1-1.456-2.483 10.95 10.95 0 0 1-.835-4.152c.02-.745.18-4.383 3.125-7.207 3.678-3.523 8.516-2.74 9.03-2.65ZM11.52 18.175c.391 0 2.952-.02 4.736-2.099 1.42-1.649 1.437-3.557 1.443-4.27V11.788c-.006-.257-.108-4.121-3.06-5.729-1.367-.744-2.721-.667-3.113-.641-1.578.109-2.657.827-3.112 1.135-.54.373-2.971 2.144-3.061 5.243-.07 2.304 1.2 3.876 1.43 4.152 1.798 2.156 4.371 2.22 4.737 2.227Z'
      fill='#085229'
    />
  </svg>
)

export default SvgPaxosStandartIcon
